// extracted by mini-css-extract-plugin
export var audioPlayer = "_rc-0";